import { Link } from 'react-router-dom';

const footerLinks = {
  快速导航: [
    { name: '首页', path: '/' },
    { name: '游戏分类', path: '/category' },
    { name: '游戏资讯', path: '/articles' },
    { name: '关于我们', path: '/about' },
  ],
  游戏类型: [
    { name: '动作射击', path: '/category?tab=action' },
    { name: '角色扮演', path: '/category?tab=rpg' },
    { name: '策略竞技', path: '/category?tab=strategy' },
    { name: '休闲益智', path: '/category?tab=casual' },
    { name: '体育竞速', path: '/category?tab=sports' },
  ],
  '关于 galagame': [
    { name: '品牌介绍', path: '/about#brand' },
    { name: '用户口碑', path: '/about#reputation' },
    { name: '联系我们', path: '/about#contact' },
    { name: '隐私政策', path: '/' },
    { name: '服务条款', path: '/' },
  ],
};

const socialLinks = [
  { icon: 'ri-wechat-line', label: '微信', href: '#' },
  { icon: 'ri-weibo-line', label: '微博', href: '#' },
  { icon: 'ri-bilibili-line', label: 'B站', href: '#' },
  { icon: 'ri-discord-line', label: 'Discord', href: '#' },
  { icon: 'ri-youtube-line', label: 'YouTube', href: '#' },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="inline-block cursor-pointer">
              <span className="font-heading text-xl font-bold text-primary-500 tracking-wider">
                GALAGAME
              </span>
            </Link>
            <p className="mt-3 text-sm text-foreground-500 leading-relaxed">
              galagame 是你不容错过的游戏平台，提供丰富的游戏内容、极致的游戏体验与高额奖励。
            </p>
            <div className="flex items-center gap-3 mt-5">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-500 hover:text-primary-500 hover:bg-primary-500/10 transition-all duration-200 cursor-pointer"
                  aria-label={social.label}
                  rel="nofollow"
                >
                  <i className={`${social.icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h3 className="font-heading text-sm font-semibold text-foreground-200 mb-4 tracking-wide">
                {title}
              </h3>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/30">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-600">
              &copy; {new Date().getFullYear()} galagame. All rights reserved.
            </p>
            <p className="text-xs text-foreground-600">
              galagame 游戏平台 | 健康游戏忠告：抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}